import React, {Component} from 'react'
import '../../static/css/style.scss'
class CardItem extends Component {
	render() {
		let item=this.props.item
		return (
			<div className={'cardItem'}>
				<div className={'cardItemText'}>
					<div className={['cardItemTextTitle',this.props.blue?'blue':null].join(' ')}>
						{item.title}
					</div>
					<div className={'cardItemTextMsg textJust'} dangerouslySetInnerHTML={{__html:item.content}}/>
				</div>
				<div className={'cardItemImg'}>
					<img src={item.img} alt=""/>
				</div>
			</div>
		)
	}
}

export default CardItem